import React, { useEffect, useState } from "react";
import api from "../../api";
import { useParams, useNavigate } from "react-router-dom";

export default function EditReasoningQuestion() {

  const { id } = useParams();
  const nav = useNavigate();
  const [form, setForm] = useState({});

  useEffect(() => {
    api.get(`/admin/reasoning/question/${id}`)
      .then(res => setForm(res.data));
  }, [id]);

  const submit = async () => {
    const fd = new FormData();
    Object.keys(form).forEach(k => fd.append(k, form[k]));
    await api.put(`/admin/reasoning/question/${id}`, fd);
    alert("Updated");
    nav("/admin/reasoning");
  };

  return (
    <div>
      <h2>Edit Reasoning</h2>
      <input value={form.option_a || ""} onChange={e => setForm({...form, option_a: e.target.value})} />
      <input value={form.option_b || ""} onChange={e => setForm({...form, option_b: e.target.value})} />
      <button onClick={submit}>Save</button>
    </div>
  );
}
